export default __webpack_public_path__ + "static/media/crc-block-user-color.5183b6a0.svg";